import { render, staticRenderFns } from "./mouthTwo.vue?vue&type=template&id=edd3b32c&scoped=true"
import script from "./mouthTwo.vue?vue&type=script&lang=js"
export * from "./mouthTwo.vue?vue&type=script&lang=js"
import style0 from "./mouthTwo.vue?vue&type=style&index=0&id=edd3b32c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd3b32c",
  null
  
)

export default component.exports